/** @format */

import DashboardHeader from "../../components/dashboard/dashboardheader";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../redux/auth";
import Share from "../../assets/images/Share.png";
import { DashboardTopSection, Menu } from "./styles";
import { API_URL } from "../../constants";
import LinkTab from "../../components/dashboard/linktab";
import HomeTab from "../../components/dashboard/hometab";
import CommunityTab from "../../components/dashboard/communitytab";
import InsightsTab from "../../components/dashboard/insights";

const Dashboard = () => {
  let [profile, setProfile] = useState<any>();
  let [subscribers, setSubscribers] = useState<any>();

  const [refreshProfile, setRefreshProfile] = useState(false);
  let [menuState, setMenuState] = useState({
    isHomeActive: true,
    isProductsActive: false,
    isInsightActive: false,
    isCustomerActive: false,
    isCommunityActive: false,
  });
  let [mainMenuState, setMainMenuState] = useState({
    isMainHomeActive: true,
    isProfileActive: false,
  });

  const handleMainHome = () => {
    setMainMenuState({
      isMainHomeActive: true,
      isProfileActive: false,
    });
  };
  const handleProfileTab = () => {
    setMainMenuState({
      isMainHomeActive: false,
      isProfileActive: true,
    });
  };
  const handleHomeTab = () => {
    setMenuState({
      isHomeActive: true,
      isProductsActive: false,
      isInsightActive: false,
      isCustomerActive: false,
      isCommunityActive: false,
    });
  };

  const handleInsightTab = () => {
    setMenuState({
      isHomeActive: false,
      isProductsActive: false,
      isInsightActive: true,
      isCustomerActive: false,
      isCommunityActive: false,
    });
  };

  const handleCommunityTab = () => {
    setMenuState({
      isHomeActive: false,
      isProductsActive: false,
      isInsightActive: false,
      isCustomerActive: false,
      isCommunityActive: true,
    });
  };
  const uuid = useSelector((state: any) => state.auth.uuid);
  const dispatch = useDispatch();

  function logOut(): void {
    dispatch(logout());
  }

  const getProfile = async () => {
    const profile: any = await fetch(`${API_URL}/profile/${uuid}`).catch((error) => {});
    if (profile) {
      let result = await profile.json();
      if (result.error) {
      }
      setProfile(result.data);
    }
  };
  const getSubscribers = async () => {
    const sub: any = await fetch(`${API_URL}/profile/subscribers/${uuid}`).catch((error) => {});
    if (sub) {
      let result = await sub.json();
      if (result.error) {
      }
      setSubscribers(result.data);
    }
  };

  useEffect(
    () => {
      getProfile();
      getSubscribers();
    },
    // eslint-disable-next-line
    [refreshProfile]
  );
  return (
    <div className="mb-[8em]">
      <DashboardHeader />
      <DashboardTopSection>
        <div className=" ">
          <div className="flex self-center  md:text-[1em] text-[0.75em] ">
            <Link to={`/${profile?.slug}`} className="view w-[9.3125em] px-5 py-2 mr-[1em] bg-black " target="_blank">
              View Page
            </Link>
            {mainMenuState.isMainHomeActive ? (
              <div className="view w-[9.3125em] px-5 py-2 bg-[#351182] cursor-pointer " onClick={handleProfileTab}>
                My Links
              </div>
            ) : (
              <div className="view w-[9.3125em] px-5 py-2 bg-[#351182] cursor-pointer " onClick={handleMainHome}>
                Home
              </div>
            )}
          </div>
          <a href="https://wa.me/message/MDP76I5CDKCGG1" target="_blank" rel="noopener noreferrer">
            <div className="view  w-[19.5rem] mt-2  px-5 py-2 bg-[#85186D] cursor-pointer ">Order a Path Card</div>
          </a>
        </div>
        <div className="md:flex md:justify-center ">
          {mainMenuState.isMainHomeActive ? (
            <Menu>
              <h5 onClick={handleHomeTab} className={menuState.isHomeActive ? "active" : ""}>
                Home
              </h5>
              <div />
              <h5 onClick={handleCommunityTab} className={menuState.isCommunityActive ? "active" : ""}>
                Community
              </h5>
              <div />
              <h5 onClick={handleInsightTab} className={menuState.isInsightActive ? "active" : ""}>
                Insights
              </h5>
            </Menu>
          ) : null}
        </div>
        <div className=" md:flex md:justify-end  ">
          <div className="visit   " onClick={logOut}>
            <h2>Log out </h2>
            <div className=" w-[1.1em] ">
              <img src={Share} alt="" className="w-[100%] h-[100%] object-contain " />
            </div>
          </div>
        </div>
      </DashboardTopSection>
      {mainMenuState.isMainHomeActive ? (
        <>
          <HomeTab
            isHomeActive={menuState.isHomeActive}
            setRefreshProfile={setRefreshProfile}
            refreshProfile={refreshProfile}
            profile={profile}
          />
          <CommunityTab isCommunityActive={menuState.isCommunityActive} profile={profile} subscribers={subscribers} />
          <InsightsTab isInsightActive={menuState.isInsightActive} uuid={uuid} />
        </>
      ) : (
        <LinkTab />
      )}
    </div>
  );
};

export default Dashboard;
